import { createFileRoute } from '@tanstack/react-router'
import PersonasSettingsPage from '@/pages/settings/personas'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/personas'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <PersonasSettingsPage />
}

